import AnnouncementFeed from '../components/AnnouncementFeed';
import { isServiceBulletinWithFile } from '../utils/announcement';

const BULLETIN_ICON = 'M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z';

export default function ServiceBulletins() {
  return (
    <AnnouncementFeed
      title="Servis Bültenleri"
      description="Servis bültenlerini görüntüleyin ve indirin"
      emptyTitle="Henüz servis bülteni bulunmuyor"
      emptyText="Servis bültenleri yayınlandığında burada görünecektir. Bültenleri kaçırmamak için düzenli olarak kontrol edin."
      errorTitle="Servis bültenleri yüklenemedi"
      iconPath={BULLETIN_ICON}
      filter={isServiceBulletinWithFile}
      downloadOnClick
    />
  );
}
